exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**  rel=\"stylesheet/scss\" lang=\"scss\"*/\n/** backgroud */\n/** border */\n/** table */\n/* Popover\n-------------------------- */\n/* Dialog\n-------------------------- */\n.wk-desc-text .tox-tinymce {\n  border: none;\n}\n.wk-desc-text .tox .tox-edit-area__iframe {\n  background-color: unset;\n}\n", ""]);

// exports
exports.locals = {
	"xrColorPrimary": "#2362FB"
};